'use strict';

function AppConfig(
  $compileProvider,
  $urlRouterProvider,
  $locationProvider,
  $httpProvider,
  $uiViewScrollProvider,
  $ocLazyLoadProvider,
  APP_CONSTANTS) {

  'ngInject';

  $compileProvider.debugInfoEnabled(APP_CONSTANTS.debugInfoState);
  $uiViewScrollProvider.useAnchorScroll();
  $httpProvider.useApplyAsync(true);
  $httpProvider.interceptors.push('nnHttpInterceptor');
  $locationProvider.html5Mode(true);
  $locationProvider.hashPrefix('!');
  $urlRouterProvider.deferIntercept();

  $ocLazyLoadProvider.config({
    modules: _mapModules([{
      name: 'AdminAccessBundle',
      rerun: true,
      files: ['bundle.app.admin-access.js']
    }, {
      name: 'CategoryBundle',
      rerun: true,
      files: ['bundle.app.category.js']
    }, {
      name: 'ErrorBundle',
      rerun: true,
      files: ['bundle.app.error.js']
    }, {
      name: 'EditPhotoModalBundle',
      rerun: true,
      files: ['bundle.app.editPhotoModal.js', 'bundle.app.editPhotoModal.css']
    }, {
      name: 'EmbedLinkModalBundle',
      rerun: true,
      files: ['bundle.app.embedLinkModal.js']
    }, {
      name: 'HomeBundle',
      rerun: true,
      files: ['bundle.app.home.js']
    }, {
      name: 'MemberBundle',
      rerun: true,
      files: ['bundle.app.member.js']
    }, {
      name: 'PicksBundle',
      rerun: true,
      files: ['bundle.app.picks.js']
    }, {
      name: 'PlaylistBundle',
      rerun: true,
      files: ['bundle.app.playlist.js']
    }, {
      name: 'PreviewsBundle',
      rerun: true,
      files: ['bundle.app.previews.js']
    }, {
      name: 'SearchBundle',
      rerun: true,
      files: ['bundle.app.search.js', 'bundle.app.search.css']
    }, {
      name: 'SeasonsBundle',
      rerun: true,
      files: ['bundle.app.seasons.js']
    }, {
      name: 'AwardsBundle',
      rerun: true,
      files: ['bundle.app.awards.js']
    }, {
      name: 'SeriesBundle',
      rerun: true,
      files: ['bundle.app.series.js']
    }, {
      name: 'StoryBundle',
      rerun: true,
      files: ['bundle.app.story.js']
    }, {
      name: 'SubscriptionsBundle',
      rerun: true,
      files: ['bundle.app.subscriptions.js']
    }, {
      name: 'TagBundle',
      rerun: true,
      files: ['bundle.app.tag.js']
    }, {
      name: 'UcpBundle',
      rerun: true,
      files: ['bundle.app.ucp.js', 'bundle.app.ucp.css']
    }, {
      name: 'UserBundle',
      rerun: true,
      files: ['bundle.app.user.js']
    }, {
      name: 'UtilityBundle',
      rerun: true,
      files: ['bundle.app.utility.js']
    }, {
      name: 'RegisterFacebookBundle',
      rerun: true,
      files: ['bundle.app.registerFacebook.js']
    }, {
      name: 'QrCodeModalBundle',
      rerun: true,
      files: ['bundle.app.qrCodeModal.js']
    }, {
      name: 'QrCodeModalBundle',
      rerun: true,
      files: ['bundle.app.qrCodeModal.js']
    }, {
      name: 'TestBundle',
      rerun: true,
      files: ['bundle.app.test.js']
    }])
  });

  function _mapModules(modules) {

    return modules.map(module => {

      module.files = module.files.map(fileName => APP_CONSTANTS.IS_BUILD ? `/assets/${fileName}` : fileName);

      return module;
    });
  }
}

export default AppConfig;



// WEBPACK FOOTER //
// ./app/app.config.js